<template>
    <div>
        <v-container style="max-width:2000px">
            <v-btn
                color="warning"
                outlined
                @click="$router.replace('/admin/newadd')"
            >
                Ny annons
                <v-icon style="margin-left:5px;margin-bottom:2px"
                    >fas fa-plus</v-icon
                >
            </v-btn>
            <h1 style="text-align:center;margin-bottom:10px">Annonser</h1>
            <v-simple-table fixed-header>
                <thead>
                    <tr>
                        <th style="background-color:#D3D3D3;font-size:20px">
                            Namn
                        </th>
                        <th style="background-color:#D3D3D3;font-size:20px">
                            Tema
                        </th>
                        <th style="background-color:#D3D3D3;font-size:20px">
                            Koda
                        </th>
                        <th style="background-color:#D3D3D3;font-size:20px">
                            Verkan
                        </th>
                    </tr>
                </thead>
                <tr v-for="ad in ads" :key="ad.id">
                    <td>{{ ad.name }}</td>
                    <td>{{ themes[ad.theme] }}</td>
                    <td>{{ ad.adcode }}</td>
                    <td>
                        <v-icon
                            @click="$router.replace(`/admin/editadd/${ad.id}`)"
                            >fas fa-edit</v-icon
                        >
                    </td>
                </tr>
                <tr style="text-align:center">
                    <td colspan="4"></td></tr
            ></v-simple-table>
        </v-container>
    </div>
</template>

<script>
import store from "../../../../store";
import axios from "axios";
export default {
    data: function() {
        return {
            store: store,
            ads: [],
            themes: [
                "Möte",
                "Övrigt",
                "Jobbmöte",
                "Svensexa",
                "Möhippa",
                "Middag",
                "Resa",
                "Fest",
                "Födelsedag",
                "Kalas",
                "Studentskiva",
                "Normal",
                "date"
            ]
        };
    },
    created: async function() {
        if (this.store.state.user.role == "user")
            this.$router.replace("/dashboard");
        if (!this.store.state.isLoggedIn) this.$router.replace("/login");
        let resp = await axios.get(`${this.store.state.baseURL}ads`);
        this.ads = resp.data.ads;
        console.log(resp);
    }
};
</script>

<style></style>
